import axios from "axios";
import { supabase } from "./supabaseClient";

// Obter API URL do sistema de configuração dinâmica
const getApiUrl = () => {
  return (
    window.ENV?.REACT_APP_API_URL ||
    process.env.REACT_APP_API_URL ||
    "/api"
  );
};

const API_URL = getApiUrl();

const axiosInstance = axios.create({
  baseURL: API_URL,
});

export const devService = {
  /**
   * Gera relatório de NIFs duplicados na tabela clientes
   * Retorna arquivo para download
   */
  async downloadDuplicateNifReport() {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para gerar relatórios."
        );
      }

      const response = await axiosInstance.get(
        `/dev/duplicate-nif-report`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        }
      );

      // Criar blob e download
      const blob = new Blob([response.data], { type: "text/plain" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // Gerar nome do arquivo com data
      const timestamp = new Date().toISOString().split("T")[0];
      link.setAttribute("download", `nif-duplicados-${timestamp}.txt`);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return {
        success: true,
        message: "Relatório baixado com sucesso"
      };
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao gerar relatório"
        );
      }
      throw error;
    }
  },

  /**
   * Busca informações sobre as tabelas do banco
   */
  async getTables() {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para acessar."
        );
      }

      const response = await axiosInstance.get(
        `/dev/tables`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao buscar tabelas"
        );
      }
      throw error;
    }
  },

  /**
   * Executa uma query simples no banco
   */
  async executeQuery(sqlQuery) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para executar queries."
        );
      }

      const response = await axiosInstance.post(
        `/dev/query`,
        { sql: sqlQuery },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao executar query"
        );
      }
      throw error;
    }
  },
};
